import React from "react";
import {
  SCROLL_OFFSET,
  H2,
  BODY_SM,
  CONTAINER,
  COL_LEFT,
  COL_RIGHT,
} from "./sections";

const STEPS = [
  {
    number: "01",
    title: "Your Voice Is Captured",
    lines: [
      "Everything starts with your microphone.",
      "When you begin speaking, your voice is captured as digital audio. The system needs to process that audio before it can turn your speech into written words.",
      "You don't need to think about individual words, punctuation marks, or formatting while you're talking. The goal is to let you communicate naturally.",
      "For someone writing an email, document, message, or note, this can make the writing process feel much more conversational.",
    ],
  },
  {
    number: "02",
    title: "Speech Is Converted Into Text",
    lines: [
      "The next step is speech-to-text transcription.",
      "The system analyzes your spoken audio and identifies the words you're saying. Instead of manually entering those words with a keyboard, you receive a text version of what you dictated.",
      "This is the fundamental capability behind voice typing.",
      "However, transcription by itself isn't necessarily the same as finished writing.",
      "A raw transcription may contain missing punctuation, awkward phrasing, repeated words, or verbal filler. That's where AI-powered text processing becomes useful.",
    ],
  },
];

const HowItWorksSection = () => {
  return (
    <section
      id="how-it-works"
      style={{ scrollMarginTop: `${SCROLL_OFFSET}px` }}
      className="w-full"
    >
      <div
        className={`${CONTAINER} pt-[64px] pb-[64px] md:pt-[88px] md:pb-[88px] lg:pt-[112px] lg:pb-[112px]`}
      >
        <div className="flex flex-col lg:flex-row lg:items-start gap-[32px] lg:gap-[58px]">
          {/* Heading rail — sticks alongside the timeline on desktop */}
          <div className={COL_LEFT}>
            <h2 className={`${H2} lg:sticky lg:top-[120px]`}>
              How Does AI Voice Typing Work?
            </h2>
          </div>

          {/* Numbered timeline */}
          <div className={COL_RIGHT}>
            <ol className="relative pl-[20px] sm:pl-[24px]">
              {/* Continuous accent rail behind the numbers */}
              <span
                aria-hidden="true"
                className="absolute left-0 top-[10px] bottom-[10px] w-[2px] rounded-full bg-gradient-to-b from-[#3AB1F6] to-[#407BFF]"
              />

              {STEPS.map(({ number, title, lines }, index) => (
                <li
                  key={number}
                  className={`flex gap-[10px] sm:gap-[14px] ${
                    index === 0 ? "" : "mt-[40px] md:mt-[48px]"
                  }`}
                >
                  <span className="mt-[5px] shrink-0 font-inter text-[11.5px] font-bold leading-[18px] tracking-[0.02em] text-[#3AB1F6]">
                    {number}
                  </span>

                  <div className="min-w-0">
                    <h3 className="font-jakarta text-[16.1px] font-bold leading-[26.16px] tracking-[0px] text-[#0A0D16]">
                      {title}
                    </h3>

                    <div className="mt-[12.88px] flex flex-col gap-[12.88px]">
                      {lines.map((line) => (
                        <p key={line} className={BODY_SM}>
                          {line}
                        </p>
                      ))}
                    </div>
                  </div>
                </li>
              ))}
            </ol>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;
